import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionPagination from "./pagination";
import { getPublishedBlogs } from "../../../controllers/blogController";
import InArticleAd from "../../Ads/inArticleAd";
import { formatDate } from "../../../utils/dateFormate";

const BlogPostsList = () => {
  const [count, setCount] = useState(1);
  const [endPost, setEndPost] = useState();
  const [startPost, setStartPost] = useState();
  const [limitPosts, setLimitPosts] = useState(6);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [postsData, setPostsData] = useState([]);

  useEffect(() => {
    setCount(1);
    getPostsData();
  }, []);

  const getPostsData = async () => {
    const FPosts = await getPublishedBlogs();
    if (Array.isArray(FPosts)) {
      // Sanitize the data immediately after fetch
      const cleanPosts = FPosts.map((post) => ({
        ...post,
        image:
          typeof post.image === "string" ? JSON.parse(post.image) : post.image,
        author:
          typeof post.author === "string"
            ? JSON.parse(post.author)
            : post.author,
      }));
      setPostsData(cleanPosts);
    }
  };

  useEffect(() => {
    if (postsData.length > 0) {
      setLimitPosts(6);
      setStartPost(postsData.length - (currentPage - 1) * 6);
      setEndPost(postsData.length - currentPage * 6);
      setTotalPages(Math.ceil(postsData.length / 6));
    }
  }, [postsData, currentPage]);

  function setCurrentPosts(page) {
    if (page === currentPage) return;
    setCurrentPage(page);
  }


  return (
    <div className="blog-posts">
      <h1 className="blog-posts__title">Read Our Latest Blogs</h1>
      <ul className="blog-posts-list">
        {postsData &&
          postsData.map((post) => {
            const imgSrc = post.image?.src
              ? post.image.src.startsWith("http")
                ? post.image.src
                : `/${post.image.src}`
              : "/assets/images/default-placeholder.jpg";
            // Safety check: only render if ID is within bounds
            if (post.id > endPost && post.id <= startPost) {
              return (
                <li key={post.id} className="blog-posts-list__post">
                  <img
                    width={100}
                    height={100}
                    loading="lazy"
                    src={imgSrc}
                    alt={post.image?.alt || "Blog post image"}
                    title={post.image?.alt || "Blog post"}
                    className="blog-posts-list__post-image"
                  />
                  <div className="blog-posts-list__post-content">
                    <h2 className="blog-posts-list__post-content-title">
                      {post.title?.length > 80
                        ? post.title.substring(0, 80) + "..."
                        : post.title}
                    </h2>
                    <p>{post.author?.name || "Anonymous"}</p>
                    <p className="blog-posts-list__post-content-date">
                      {formatDate(post.date)}
                    </p>
                    <p
                      className="blog-posts-list__post-content-summary"
                      dangerouslySetInnerHTML={{
                        __html:
                          post.summary?.length > 150
                            ? post.summary.substring(0, 150) + "..."
                            : post.summary,
                      }}
                    />
                    <InArticleAd />
                    <Link
                      to={`/blog/${post.slug}`}
                      className="blog-posts-list__post-content-button"
                    >
                      Read more
                    </Link>
                  </div>
                </li>
              );
            }
            return null;
          })}
      </ul>

      {postsData.length > 0 && totalPages > 0 ? (
        <SectionPagination
          total={postsData.length}
          count={count}
          limit={limitPosts}
          total_pages={totalPages}
          setCurrentPosts={setCurrentPosts}
          currentPage={currentPage}
        />
      ) : null}
    </div>
  );
};

export default BlogPostsList;
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import SectionPagination from "./pagination";
// import { getPublishedBlogs } from "../../../controllers/blogController";
// import InArticleAd from "../../Ads/inArticleAd";

// const BlogPostsList = () => {
//   const [count, setCount] = useState(1);
//   const [endPost, setEndPost] = useState();
//   const [startPost, setStartPost] = useState();
//   const [limitPosts, setLimitPosts] = useState(6);
//   const [totalPages, setTotalPages] = useState();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [postsData, setPostsData] = useState([]);

//   useEffect(() => {
//     setCount(1);
//     getPostsData();
//   }, []);

//   const getPostsData = async () => {
//     const FPosts = await getPublishedBlogs();
//     if (FPosts.length > 0) {
//       // console.log("Fetched posts data:", FPosts); // Log the fetched posts data
//       setPostsData(FPosts);
//     }
//   };

//   useEffect(() => {
//     if (postsData.length > 0) {
//       setLimitPosts(6);
//       setStartPost(postsData.length * currentPage);
//       setEndPost(postsData.length - limitPosts);
//       setTotalPages(Math.ceil(postsData.length / limitPosts));
//     }
//   }, [postsData, limitPosts]); // changes made here to add currentPage and limitPosts as dependencies

//   function setCurrentPosts(page) {
//     if (page === currentPage) return;
//     if (postsData.length > 0) {
//       setCurrentPage(page);
//       const postsStart = postsData.length - (page - 1) * limitPosts;
//       const postsEnd = postsStart - limitPosts;
//       setStartPost(postsStart);
//       setEndPost(postsEnd);
//       // getPostsData();
//     }
//   }
//   return (
//     <div className="blog-posts">
//       <h1 className="blog-posts__title">Read Our Latest Blogs</h1>
//       <ul className="blog-posts-list">
//         {postsData &&
//           postsData.map((post) => {
//             if (post.id > endPost && post.id <= startPost) {
//               return (
//                 <li key={post.id} className="blog-posts-list__post">
//                   <img
//                     width={100}
//                     height={100}
//                     loading="lazy"
//                     src={`${
//                       post.image.src.startsWith("http://") || post.image.src.startsWith("https://")
//                         ? post.image.src
//                         : `/${post.image.src}`
//                     }`}
//                     alt={post.image.alt}
//                     title={post.image.alt}
//                     className="blog-posts-list__post-image"
//                   />
//                   <div className="blog-posts-list__post-content">
//                     <h2 className="blog-posts-list__post-content-title">
//                       {post.title.length > 80
//                         ? post.title.substring(0, 80) + "..."
//                         : post.title}
//                     </h2>
//                     <p>{post.author.name}</p>
//                     <p className="blog-posts-list__post-content-date">
//                       {post.date}
//                     </p>
//                     <p
//                       className="blog-posts-list__post-content-summary"
//                       dangerouslySetInnerHTML={{
//                         __html:
//                           post.summary.length > 150
//                             ? post.summary.substring(0, 150) + "..."
//                             : post.summary,
//                       }}
//                     />
//                     <InArticleAd />
//                     <Link
//                       to={`/blog/${post.slug}`}
//                       className="blog-posts-list__post-content-button"
//                     >
//                       Read more
//                     </Link>
//                   </div>
//                 </li>
//               );
//             } else {
//               return null;
//             }
//           })}
//       </ul>

//       {postsData.length > 0 && totalPages > 0 ? (
//         <SectionPagination
//           total={postsData.length}
//           count={count}
//           limit={limitPosts}
//           total_pages={totalPages}
//           setCurrentPosts={setCurrentPosts}
//           currentPage={currentPage}
//         />
//       ) : null}
//     </div>
//   );
// };

// export default BlogPostsList;
